import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { useIntl, useSelector } from "@grandvisionhq/state";
import { GooglePaySessionErrors } from "../../../../../../../../../../mappers/mappers/errors-mapping.js";
import { getSelectedPickupPoint, getSelectedStore } from "../../../../../../../../../../StepShipping/StepShipping/selectors.js";
import { mapGooglePayContactAddress } from "../../../../../../mappers/modules/ExpressCheckout/hooks/google-pay/mappers/google-pay-contact-address.js";
import { isNearestPickup, isPickupPoint, isPickupStore } from "../../../../../../../../../../utils/utils/shipping-method.js";
const useMapShippingAddress = () => {
  const { country, getLabel } = useIntl();
  const selectedPickupPoint = useSelector(getSelectedPickupPoint);
  const selectedStore = useSelector(getSelectedStore);
  const selectedStoreRef = React.useRef(selectedStore);
  const selectedPickupPointRef = React.useRef(selectedPickupPoint);
  React.useEffect(() => {
    selectedStoreRef.current = selectedStore;
  }, [selectedStore]);
  React.useEffect(() => {
    selectedPickupPointRef.current = selectedPickupPoint;
  }, [selectedPickupPoint]);
  return React.useCallback(
    (googlePayment, shippingMethod) => {
      const billingAddress = googlePayment.paymentMethodData.info?.billingAddress;
      if (!billingAddress) {
        return;
      }
      const isNearestPickup$1 = isNearestPickup(shippingMethod);
      const isPickupPoint$1 = isPickupPoint(shippingMethod);
      const isStorePickUp = isPickupStore(shippingMethod);
      if (isNearestPickup$1) {
        if (billingAddress.countryCode !== country) {
          toast.failed(GooglePaySessionErrors.GooglePayInvalidAddress);
          throw getLabel(GooglePaySessionErrors.GooglePayInvalidAddress);
        }
        return mapGooglePayContactAddress(googlePayment, "billingAddress");
      }
      if (isPickupPoint$1) {
        const contactAddress = mapGooglePayContactAddress(googlePayment);
        return {
          ...contactAddress,
          firstName: contactAddress?.firstName ?? "",
          lastName: contactAddress?.lastName ?? "",
          city: selectedPickupPointRef.current?.town ?? "",
          streetName: selectedPickupPointRef.current?.streetName ?? "",
          streetNumber: selectedPickupPointRef.current?.streetNumber ?? void 0,
          postalCode: selectedPickupPointRef.current?.postalCode ?? "",
          additionalAddressInfo: "",
          additionalStreetInfo: selectedPickupPointRef.current?.additionalStreetInfo ?? "",
          countryCode: selectedPickupPointRef.current?.country ?? "",
          externalId: selectedPickupPointRef.current?.globalPickupPointId ?? void 0,
          company: selectedPickupPointRef.current?.name ?? void 0
        };
      }
      if (isStorePickUp) {
        const contactAddress = mapGooglePayContactAddress(googlePayment);
        return {
          ...contactAddress,
          firstName: contactAddress?.firstName ?? "",
          lastName: contactAddress?.lastName ?? "",
          city: selectedStoreRef.current?.town ?? "",
          streetName: selectedStoreRef.current?.streetName ?? "",
          streetNumber: selectedStoreRef.current?.streetNumber ?? void 0,
          postalCode: selectedStoreRef.current?.postalCode ?? "",
          additionalAddressInfo: "",
          additionalStreetInfo: selectedStoreRef.current?.additionalStreetInfo ?? "",
          countryCode: selectedStoreRef.current?.country ?? "",
          externalId: selectedStoreRef.current?.globalStoreId ?? void 0,
          company: selectedStoreRef.current?.name ?? void 0
        };
      }
      return mapGooglePayContactAddress(googlePayment);
    },
    [country, getLabel]
  );
};
export {
  useMapShippingAddress
};
//# sourceMappingURL=use-map-shipping-address.js.map
